const CATEGORIES = require('./categories');
const isRealInsurance = (item) => /INSURANCE/.test((item.extra || {}).insuranceType || '');

class GetterDispatcher {
    constructor(cart) {
        this.cart = cart;
    }

    insurances(filter = () => true) {
        return this.cart.getItemsByCategory(CATEGORIES.INSURANCE, filter);
    }

    realInsurances(filter = () => true) {
        return this.cart.getItemsByCategory(CATEGORIES.INSURANCE, (item) => filter(item) && isRealInsurance(item));
    }

    serviceOptions(filter = () => true) {
        return this.cart.getItemsByCategory(CATEGORIES.SERVICE_OPTION, filter);
    }

    fareRules(filter = () => true) {
        return this.cart.getItemsByCategory(CATEGORIES.FARE_RULE, filter);
    }

    seats(filter = () => true) {
        return this.cart.getItemsByCategory(CATEGORIES.SEATS, filter);
    }

    boardingOptions(filter = () => true) {
        return this.cart.getItemsByCategory(CATEGORIES.BOARDING_OPTIONS, filter);
    }

    bags(filter = () => true) {
        return this.cart.getItemsByCategory(CATEGORIES.BAGGAGE, filter);
    }

    fastTrack(filter = () => true) {
        return this.cart.getItemsByCategory(CATEGORIES.FAST_TRACK, filter);
    }
}

module.exports = (cart) => new GetterDispatcher(cart);

